import { Box, Button, Dialog, DialogContent, Typography } from '@mui/material'
import { useTranslation } from 'react-i18next'
import { goToInfoPage } from 'utils/functions'
import { ReactComponent as Logo } from '../../assets/svg/Logo.svg'
import { ReactComponent as Copyright } from '../../assets/svg/copyright.svg'
import { ReactComponent as Launch } from '../../assets/svg/launch.svg'
import DialogHeader from './DialogHeader'

const DialogInfoApp = ({ onClose, currentLang }) => {
    const currentYear = new Date().getFullYear();
    const { t } = useTranslation()

    return (
        <Dialog
            open modal={true}
            onClose={onClose}
            aria-labelledby="alert-dialog-title" aria-describedby="alert-dialog-description"
            maxWidth="sm"
            fullWidth>
            <DialogHeader onClose={onClose} />
            <DialogContent sx={{ pb: 2 }}>
                <Box display={'flex'} flexDirection={'column'} alignItems={'center'} justifyContent={'center'}>
                    <Logo width="134px" height="56" />
                    <Typography pt={3} fontSize={18} fontWeight={600}>{t('infoAbout.version', { year: currentYear })}</Typography>
                    {
                        currentLang === "vi"
                            ?
                            <div style={{ display: 'flex', paddingTop: "24px", gap: '5px' }}>
                                <Typography fontWeight={600} sx={{ paddingLeft: "5px" }}><Copyright /> 2021 {t('infoAbout.Copyright')}</Typography>
                            </div>
                            :
                            <div style={{ display: 'flex', paddingTop: "24px", gap: '5px' }}>
                                <Typography fontWeight={600} sx={{ paddingLeft: "5px" }}>{t('infoAbout.Copyright')} <Copyright /> 2021 </Typography>
                            </div>
                    }
                    <Typography fontWeight={600}>{t('infoAbout.company')}</Typography>
                    <Button fullWidth variant="text" style={{ width: '300px', marginTop: "48px", backgroundColor: "white", color: "#C7002B", cursor: "pointer" }} onClick={goToInfoPage}>
                        <Typography fontWeight={600} sx={{ paddingRight: "5px" }}>{t('infoAbout.conferenceMeeting')}</Typography>
                        <Launch />
                    </Button>
                </Box>
            </DialogContent>
        </Dialog>
    )
}

export default DialogInfoApp